__turbopack_context__.v({
  "button": "RoundedIconButton-module-scss-module__Mk-JQW__button",
  "roundedIconButton": "RoundedIconButton-module-scss-module__Mk-JQW__roundedIconButton",
});
